import { Jumbotron, ButtonGroup, Button } from 'react-bootstrap';

const Delivery = () => {
    return (
        <>
            <Jumbotron>
                <h1>ТОО "Синомост" | Доставка продукци</h1>
                <p>На данный момент мы поставляем 3 вида продукции:</p>
                <ul>
                    <li>Спецтехнику</li>
                    <li>Автомобили</li>
                    <li>Детали (запчасти) для техники и авто</li>
                </ul>
                <p>По любым вопросам Вы можете связаться с нами, нажав на кнопки ниже:</p>
                <ButtonGroup>
                    <a href="https://wa.me/77015471529" target="_blank" className="btn btn-success">Написать в Whatsapp</a>
                    <a href="tel:+77015471529" className="btn btn-light">Позвонить</a>
                </ButtonGroup>
            </Jumbotron>
        </>
    );
};

export default Delivery;
